import React from 'react';
import { useUserData, FrequencyOption } from '@/context/UserDataContext';
import { getExerciseFrequencyOptions } from '../../shared/constants';
import { FormSection } from '../../shared/FormSection';
import AnimatedSelectionGroup from '../../AnimatedSelectionGroup';

interface ExerciseFrequencyProps {
  error?: string;
  onComplete: (value: FrequencyOption) => void;
}

const ExerciseFrequency: React.FC<ExerciseFrequencyProps> = ({ error, onComplete }) => {
  const { userData, setUserData } = useUserData();
  const exerciseOptions = getExerciseFrequencyOptions();

  const handleExerciseFrequencyChange = (value: FrequencyOption) => {
    setUserData(prev => ({
      ...prev,
      exerciseFrequency: value,
      // Clear exercise types if 'never' is selected
      exerciseType: value === 'never' ? [] : prev.exerciseType
    }));
    // Call onComplete with the new value
    onComplete(value);
  };

  return (
    <FormSection
      question="How often do you exercise?"
      helperText="The amount of exercise you do can affect your need to supplement with certain vitamins and minerals."
      error={error}
    >
      <AnimatedSelectionGroup
        options={exerciseOptions}
        value={userData.exerciseFrequency}
        onChange={handleExerciseFrequencyChange}
        name="exercise-frequency"
      />
    </FormSection>
  );
};

export default ExerciseFrequency; 